import { TourItemStep } from "./tourItemSteps";

export class userGuideService {

    static getQuickStartGuide(): TourItemStep[] {
        const steps: TourItemStep[] = [
            {
                id: "step-1",
                target: "#tab-fileUpload",
                title: "quickStartTour.newFile",
                description: "quickStartTour.newFileDescription",
            },
            {
                id: "step-2",
                target: "#source-lagnuage",
                title: "quickStartTour.sourceLanguage",
                description: "quickStartTour.sourceLanguageDescription",
            },
            {
                id: "step-3",
                target: "#target-laguage",
                title: "quickStartTour.targetLanguage",
                description: "quickStartTour.targetLanguageDescription",
            },
            {
                id: "step-4",
                target: "#translation-subject",
                title: "quickStartTour.subject",
                description: "quickStartTour.subjectDescription",
            },
            {
                id: "step-5",
                target: "#translation-sub-subject",
                title: "quickStartTour.subSubject",
                description: "quickStartTour.subSubjectDescription",
            },
            {
                id: "step-6",
                target: "#file-upload",
                title: "quickStartTour.selectFile",
                description: "quickStartTour.selectFileDescription",
            },
            {
                id: "step-7",
                target: "#submitt-file",
                title: "quickStartTour.submit",
                description: "quickStartTour.submitDescription",
            },
            {
                id: "step-8",
                target: "#shortcut-button",
                title: "quickStartTour.informationButton",
                description: "quickStartTour.informationButtonDescription",
            },
        ]

        return steps;
    }

    static getHomePage(): TourItemStep[] {
        const steps: TourItemStep[] = [
            {
                id: "step-1",
                target: "#go-home",
                title: "homePageTour.homePageButton",
                description: "homePageTour.homePageButtonDescription",
            },
            {
                id: "step-2",
                target: "#admin-site",
                title: "homePageTour.adminSite",
                description: "homePageTour.adminSiteDescription",
            },
            {
                id: "step-3",
                target: "#shortcut-button",
                title: "homePageTour.information",
                description: "homePageTour.informationDescription",
            },
            {
                id: "step-5",
                target: "#tab-userDocuments",
                title: "homePageTour.continueTranslation",
                description: "",
            },
            {
                id: "step-6",
                target: "#tab-fileUpload",
                title: "homePageTour.uploadNewDocument",
                description: "",
            },
            {
                id: "step-7",
                target: "#tab-archiveDocuments",
                title: "homePageTour.archiveDocuments",
                description: "",
            },
        ]

        return steps;
    }

    static getConfigurationTour(): TourItemStep[] {
        const steps: TourItemStep[] = [
            {
                id: "step-1",
                target: "#tab-fileUpload",
                title: "translationConfigTour.newFileTab",
                description: "translationConfigTour.newFileTabDescription",
            },
            {
                id: "step-2",
                target: "#configuration-colapse",
                title: "translationConfigTour.translationSettings",
                description: "translationConfigTour.translationSettingsDescription",
            },
            {
                id: "step-3",
                target: "#source-lagnuage",
                title: "translationConfigTour.sourceLanguage",
                description: "",
            },
            {
                id: "step-4",
                target: "#target-laguage",
                title: "translationConfigTour.targetLanguage",
                description: "",
            },
            {
                id: "step-5",
                target: "#swap-languages",
                title: "translationConfigTour.swapLanguages",
                description: "",
            },
            {
                id: "step-6",
                target: "#fuzzy-match",
                title: "translationConfigTour.fuzzyMatch",
                description: "translationConfigTour.fuzzyMatchDescription",
            },
            {
                id: "step-7",
                target: "#open-variants-popup",
                title: "translationConfigTour.openVariantsPopup",
                description: "translationConfigTour.openVariantsPopupDescription",
            },
            {
                id: "step-8",
                target: "#translation-subject",
                title: "translationConfigTour.filters",
                description: "translationConfigTour.filtersDescription",
            },
            {
                id: "step-9",
                target: "#project-code",
                title: "translationConfigTour.projectCode",
                description: "translationConfigTour.projectCodeDescription",
            },
            {
                id: "step-10",
                target: "#paragraph-style",
                title: "translationConfigTour.paragraphStyle",
                description: "translationConfigTour.paragraphStyleDescription",
            },
            {
                id: "step-11",
                target: "#use-external-translations",
                title: "translationConfigTour.externalTranslations",
                description: "",
            },
            {
                id: "step-12",
                target: "#translation-providers",
                title: "translationConfigTour.translationProvider",
                description: "",
            },
        ]

        return steps;
    }

    static getLoadTranslation(): TourItemStep[] {
        const steps: TourItemStep[] = [
            {
                id: "step-1",
                target: "#source-container",
                title: "loadTranslationTour.sourceText",
                description: "loadTranslationTour.sourceTextDescription",
            },
            {
                id: "step-2",
                target: "#translate-button",
                title: "loadTranslationTour.translate",
                description: "loadTranslationTour.translateDescription",
            },

            {
                id: "step-3",
                target: "#info-items",
                title: "loadTranslationTour.translationMatch",
                description: "loadTranslationTour.translationMatchDescription",
            },
        ]

        return steps;
    }

    static getUpdateTranslation(): TourItemStep[] {
        const steps: TourItemStep[] = [
            {
                id: "step-1",
                target: "#segment-container",
                title: "updateTranslationTour.edit",
                description: "updateTranslationTour.editDescription",
            },
            {
                id: "step-2",
                target: "#variants-button",
                title: "updateTranslationTour.couldBeEdited",
                description: "updateTranslationTour.couldBeEditedDescription",
                    
            },
            {
                id: "step-3",
                target: "#tareget-container",
                title: "updateTranslationTour.editTranslationText",
                description: "updateTranslationTour.editTranslationTextDescription",
            },
            {
                id: "step-4",
                target: "#update-button",
                title: "updateTranslationTour.updateTranslation",
                description: "updateTranslationTour.updateTranslationDescription",
            },
        ]

        return steps;
    }

    static getSegmentControls(): TourItemStep[] {
        const steps: TourItemStep[] = [
            {
                id: "step-1",
                target: "#row-number",
                title: "translationSegmentTour.segmentNumber",
                description: ""
            },
            {
                id: "step-2",
                target: "#source-container",
                title: "translationSegmentTour.sourceText",
                description: ""
            },
            {
                id: "step-3",
                target: "#tareget-container",
                title: "translationSegmentTour.targetText",
                description: ""
            },
            {
                id: "step-4",
                target: "#clear-button",
                title: "translationSegmentTour.clearButton",
                description: ""
            },
            {
                id: "step-5",
                target: "#translate-button",
                title: "translationSegmentTour.loadTranslation",
                description: ""
            },
            {
                id: "step-6",
                target: "#variants-button",
                title: "translationSegmentTour.variantsButton",
                description: ""
            },
            {
                id: "step-7",
                target: "#update-button",
                title: "translationSegmentTour.updateButton",
                description: ""
            },
            {
                id: "step-8",
                target: "#save-button",
                title: "translationSegmentTour.saveButton",
                description: ""
            },
            {
                id: "step-9",
                target: "#copy-button",
                title: "translationSegmentTour.copyButton",
                description: ""
            },
            {
                id: "step-10",
                target: "#info-items",
                title: "translationSegmentTour.segmentState",
                description: "translationSegmentTour.segmentStateDescription",
            },
            {
                id: "step-11",
                target: "#find-next-segmet-container",
                title: "translationSegmentTour.findNextSegment",
                description: "translationSegmentTour.findNextSegmentDescription",
            },
        ]

        return steps;
    }

    static getDocumentActions(): TourItemStep[] {
        const steps: TourItemStep[] = [
            {
                id: "step-1",
                target: "#translate-all",
                title: "documnetActionsTour.translateAll",
                description: "documnetActionsTour.translateAllDescription",
            },
            {
                id: "step-2",
                target: "#save-drafts",
                title: "documnetActionsTour.saveDrafts",
                description: "documnetActionsTour.saveDraftsDescription",
            },
            {
                id: "step-3",
                target: "#clear-document",
                title: "documnetActionsTour.clearDocument",
                description: "documnetActionsTour.clearDocumentDescription",
            },
            {
                id: "step-4",
                target: "#download-document",
                title: "documnetActionsTour.downloadDocument",
                description: "documnetActionsTour.downloadDocumentDescription",
            },
        ]

        return steps;
    }

    static getDocumentSearch(): TourItemStep[] {
        const steps: TourItemStep[] = [
            {
                id: "step-1",
                target: "#search-control",
                title: "documentSearchTour.searchControl",
                description: "documentSearchTour.searchControlDescription",
            },
            {
                id: "step-2",
                target: "#search-source-tab",
                title: "documentSearchTour.sourceTab",
                description: "documentSearchTour.sourceTabDescription",
            },
            {
                id: "step-3",
                target: "#search-target-tab",
                title: "documentSearchTour.targetTab",
                description: "documentSearchTour.targetTabDescription",
            },
            {
                id: "step-4",
                target: "#search-input",
                title: "documentSearchTour.searchInput",
                description: "documentSearchTour.searchInputDescription",
            },
        ]

        return steps;
    }

    static getConcordanceSearch(): TourItemStep[] {
        const steps: TourItemStep[] = [
            {
                id: "step-2",
                target: "#concordance-source-input",
                title: "concordanceSearchTour.sourceInput",
                description: "concordanceSearchTour.sourceInputDescription",
            },
            {
                id: "step-3",
                target: "#concordance-target-input",
                title: "concordanceSearchTour.targetInput",
                description: "concordanceSearchTour.targetInputDescription",
            },
            {
                id: "step-4",
                target: "#concordance-search-btn",
                title: "concordanceSearchTour.searchButton",
                description: "concordanceSearchTour.searchButtonDescription",
            },
            {
                id: "step-5",
                target: "#concordance-results",
                title: "concordanceSearchTour.results",
                description: "concordanceSearchTour.resultsDescription",
            },
        ]

        return steps;
    }

}
